import { OptimizelyFeatureFlags } from 'constants/featureFlags'
import { getOptimizelyFeatureFlagVariation, isAllowedToTriggerExperiment } from 'lib/optimizely/optimizelyUtils'

function isCheckoutFeatureFlagEnabled(state: App.State, flagId: OptimizelyFeatureFlags): boolean {
  return isAllowedToTriggerExperiment(true, state.utm.content, flagId) && getOptimizelyFeatureFlagVariation(state, flagId)
}

/** Customer overlapping same-property extra-room lead names. Agent Hub keeps the legacy form. */
export default function isOverlappingRoomGuestNamesEnabled(state: App.State): boolean {
  return isCheckoutFeatureFlagEnabled(state, OptimizelyFeatureFlags.croCollectOverlappingRoomGuestNames)
}

/** Includes Flash rooms in customer overlapping room guest name collection. */
export function isOverlappingFlashRoomGuestNamesEnabled(state: App.State): boolean {
  return isCheckoutFeatureFlagEnabled(state, OptimizelyFeatureFlags.croCollectOverlappingRoomGuestNameFlash)
}
